import { Image } from "@chakra-ui/react";

interface NavigationButtonProps {
  direction: "left" | "right";
  className: string;
}

export const NavigationButton = (props: NavigationButtonProps) => {
  const { direction, className } = props;

  return (
    <Image
      cursor="pointer"
      src={`${process.env.PUBLIC_URL}/assets/images/arrow-${direction}.svg`}
      alt={direction === "left" ? "Previous" : "Next"}
      className={className}
      boxSize="36px"
      position="absolute"
      top="50%"
      left={direction === "left" ? "-50px" : "unset"}
      right={direction === "right" ? "-50px" : "unset"}
      transform="translateY(-50%)"
      _hover={{
        transform: "translateY(-50%) scale(1.25)",
        transition: "transform 0.25s",
      }}
    />
  );
};
